const initialState = {};

export default (state = initialState, action) => {
	switch (action.type) {
		case "ORGANIZATIONS_IS_LOADING":
			return {
				...state,
				isLoading: 1
			};
		case "ORGANIZATIONS_HAS_ERROR":
			return {
				...state,
				isLoading: 0,
				error: action.error
			};
		case "ORGANIZATIONS_SUCCESS":
			return {
				...state,
				organizations: action.data.organizations,
				isLoading: 0
			};

		default:
			return state;
	}
};



// WEBPACK FOOTER //
// ./src/store/reducers/organizations.js